import './Icon.less'
import Icon from './Icon'
export default Icon
